import React from "react";
import PropTypes from "prop-types";
import "./heading.css";

const Heading = ({ title, styles, h1 = true }) => {
  if (h1)
    return (
      <div className="heading__wrapper" style={{ ...styles }}>
        <h1 className="title">{title}</h1>
      </div>
    );
  else {
    return (
      <div className="heading__wrapper" style={{ ...styles }}>
        <h2 className="title">{title}</h2>
      </div>
    );
  }
};

Heading.propTypes = {
  title: PropTypes.string,
  styles: PropTypes.object,
};

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading.js